import React from 'react';

//hooks
import useCarousel, {defaultCarouselOptions} from '@stencil/hook-use-carousel';

//styles
import * as S from './GoTribeBenefits.styles';

//Types
import {GoTribeInfo} from '@stencil/hotels-types/src/details-cg/types';

const contentLength = 50;

interface GoTribeBenefitsProps {
  goTribeBenefits: GoTribeInfo;
  isMweb?: boolean;
}

export const GoTribeBenefits = ({goTribeBenefits, isMweb = false}: GoTribeBenefitsProps) => {
  const {emblaRef, scrollPrevious, scrollNext, leftArrowIsActive, rightArrowIsActive} = useCarousel(
    {
      ...defaultCarouselOptions,
      isScroll: isMweb,
    },
  );

  if (!goTribeBenefits?.benefits?.length) return null;

  return (
    <S.MainWrapper $isMweb={isMweb}>
      <S.HeaderWrapper $isMweb={isMweb}>
        <S.goTribeIcon src={goTribeBenefits?.goTribeIconUrlV2} $isMweb={isMweb} />
        <S.HeaderText>{goTribeBenefits?.title || 'BENEFITS'}</S.HeaderText>
        <S.HeaderGradientLine />
      </S.HeaderWrapper>
      <S.GoTribeBenefitsWrapper>
        <S.FeatureListWrapper ref={emblaRef}>
          <S.FeatureList>
            {goTribeBenefits?.benefits?.map(item => (
              <S.FeatureListItem>
                <S.ItemIconWrapper>
                  <S.ItemIcon src={item?.iconUrlV2 || item?.iconUrl} />
                </S.ItemIconWrapper>
                <S.ItemDesc>{item?.value || item?.text}</S.ItemDesc>
              </S.FeatureListItem>
            ))}
          </S.FeatureList>
        </S.FeatureListWrapper>
        {rightArrowIsActive && !isMweb && (
          <S.ArrowNext onClick={scrollNext}>
            <span className="arrowNextIcon"></span>
          </S.ArrowNext>
        )}
        {leftArrowIsActive && !isMweb && (
          <S.ArrowPrev onClick={scrollPrevious}>
            <span className="arrowPrevIcon"></span>
          </S.ArrowPrev>
        )}
      </S.GoTribeBenefitsWrapper>
    </S.MainWrapper>
  );
};

export default GoTribeBenefits;
